import { Card } from "react-bootstrap";

interface Props {
    mode: "level" | "rank";
    level: string;
    status: string;
    rank: string;
    selectedColumns: string[];
}

const ExportSummary = ({
    mode,
    level,
    status,
    rank,
    selectedColumns
}: Props) => {
    return (
        <Card
            className="border-0 rounded-4 px-4 py-2 h-100"
            style={{
                background: "#0d1117",
                color: "#fff"
            }}
        >
            <div className="mb-5">
                <h5 className="fw-bold mb-1">
                    3. Resumen de la exportación
                </h5>
            </div>

            <div className="d-flex align-items-center mb-4">
                <div
                    className="rounded-3 d-flex align-items-center justify-content-center me-3"
                    style={{
                        width: 42,
                        height: 42,
                        background: "#1A1E24",
                        border: "1px solid rgba(255,255,255,.06)"
                    }}
                >
                    <i
                        className="ri-filter-3-line"
                        style={{
                            color: "#fff",
                            fontSize: 18
                        }}
                    />
                </div>

                <div>
                    <div className="text-secondary small">
                        Modo de exportación
                    </div>

                    <div
                        className="fw-semibold"
                        style={{ color: "#43D131" }}
                    >
                        {mode === "level"
                            ? "Por Nivel"
                            : "Por Rango"}
                    </div>
                </div>
            </div>

            <div className="d-flex align-items-center mb-4">
                <div
                    className="rounded-3 d-flex align-items-center justify-content-center me-3"
                    style={{
                        width: 42,
                        height: 42,
                        background: "#1A1E24",
                        border: "1px solid rgba(255,255,255,.06)"
                    }}
                >
                    <i
                        className={
                            mode === "level"
                                ? "ri-stack-line"
                                : "ri-vip-crown-line"
                        }
                        style={{
                            color: "#fff",
                            fontSize: 18
                        }}
                    />
                </div>

                <div>
                    <div className="text-secondary small">
                        {mode === "level"
                            ? "Nivel seleccionado"
                            : "Rango seleccionado"}
                    </div>

                    <div
                        className="fw-semibold"
                        style={{ color: "#43D131" }}
                    >
                        {mode === "level"
                            ? level || "Todos los niveles"
                            : rank || "Todos los rangos"}
                    </div>
                </div>
            </div>

            {/* Estado */}
            <div className="d-flex align-items-center mb-4">
                <div
                    className="rounded-3 d-flex align-items-center justify-content-center me-3"
                    style={{
                        width: 42,
                        height: 42,
                        background: "#1A1E24",
                        border: "1px solid rgba(255,255,255,.06)"
                    }}
                >
                    <i
                        className="ri-user-follow-line"
                        style={{
                            color: "#fff",
                            fontSize: 18
                        }}
                    />
                </div>

                <div>
                    <div className="text-secondary small">
                        Estado
                    </div>

                    <div
                        className="fw-semibold"
                        style={{ color: "#43D131" }}
                    >
                        {status || "Todos"}
                    </div>
                </div>
            </div>

            {/* Columnas */}
            <div className="d-flex align-items-center mb-4">
                <div
                    className="rounded-3 d-flex align-items-center justify-content-center me-3"
                    style={{
                        width: 42,
                        height: 42,
                        background: "#1A1E24",
                        border: "1px solid rgba(255,255,255,.06)"
                    }}
                >
                    <i
                        className="ri-layout-grid-line"
                        style={{
                            color: "#fff",
                            fontSize: 18
                        }}
                    />
                </div>

                <div>
                    <div className="text-secondary small">
                        Columnas seleccionadas
                    </div>

                    <div
                        className="fw-semibold"
                        style={{ color: "#43D131" }}
                    >
                        {selectedColumns.length} columnas
                    </div>
                </div>
            </div>

            {/* Formato */}
            <div className="d-flex align-items-center mb-5">
                <div
                    className="rounded-3 d-flex align-items-center justify-content-center me-3"
                    style={{
                        width: 42,
                        height: 42,
                        background: "#1A1E24",
                        border: "1px solid rgba(255,255,255,.06)"
                    }}
                >
                    <i
                        className="ri-file-excel-2-line"
                        style={{
                            color: "#fff",
                            fontSize: 18
                        }}
                    />
                </div>

                <div>
                    <div className="text-secondary small">
                        Formato
                    </div>

                    <div
                        className="fw-semibold"
                        style={{ color: "#43D131" }}
                    >
                        Excel (.xlsx)
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default ExportSummary;